import styled from 'styled-components'

interface IDataManagerSearchStyledProps {}

export const DataManagerSearchStyled = styled.div<IDataManagerSearchStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: relative;

  .manual-trigger-text {
    position: absolute;

    bottom: ${(props) => `-${props.theme.space.xsmall}`};
    transform: translateY(100%);
  }
`
